import NewStaticTable from "components/staticTable/NewStaticTable";

import Modal from "global/Modal/Modal";
import React, { useEffect, useState } from "react";
import { TerminalHistoryColumns } from "./terminal-columns";
import { useDispatch, useSelector } from "react-redux";
import { filterTerminalHistory } from "redux/define-terminal/termianl-history";
import { Pagination } from "react-pagination-bar";
import { getDay } from "tools/functions/Methods";

function TerminalHistory({ open, setOpen, terminalId }) {
  const [pageTable, setpageTable] = useState(1);
  const dispatch = useDispatch();
  const { terminalHistoryData, fetchpost } = useSelector(
    (state: any) => state.TerminalHistorySlice
  );

  let data =
    terminalHistoryData?.response?.items !== 0
      ? terminalHistoryData?.response?.items?.map((item: any) => {
          return {
            ...item,
            assignmentDate: getDay(item.assignmentDate) ,
            cancellationDate: getDay(item.cancellationDate) ,
          };
        })
      : [];

  useEffect(() => {
    if (!open || !terminalId) return;
    dispatch(
      filterTerminalHistory({
        id: terminalId,
        pageSize: 10,
        pageNumber: pageTable,
      }) as any
    );
  }, [open]);

  return (
    <Modal visible={open} setVisible={setOpen} title={"سابقه ترمینال"}>
      {/* <div className="text-gray-500 mb-4 w-96">
        <span>شماره ترمینال: </span>
        <span className="text-gray-800 font-semibold">12345678</span>
      </div> */}

      <NewStaticTable
        data={data ?? []}
        THWrapper={"whitespace-nowrap"}
        column={TerminalHistoryColumns}
        ignoreRedux={true}
        loading={fetchpost}
      />

      <div className="Pagination">
        <Pagination
          currentPage={pageTable}
          itemsPerPage={10}
          onPageChange={(pageNumber) => {
            console.log("run")
            dispatch(
              filterTerminalHistory({
                id: terminalId,
                pageSize: 10,
                pageNumber: pageNumber,
              }) as any
            );
            setpageTable(pageNumber);
          }}
          totalItems={terminalHistoryData?.response?.totalItems}
          pageNeighbours={2}
          customClassNames={{
            rpbItemClassNameActive: "pagination_style",
          }}
        />
      </div>
    </Modal>
  );
}

export default TerminalHistory;
